import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import ModalPage from "../../../../layout/ModalPage";
import LabelNumber from "../../../../components/input/LabelNumber";
import { SelectSucursales } from "../../../../components/select/SelectSucursales";
import { useForm } from "./useForm";
import { ListaItems } from "./_ListaItems";

export const ModalCarretero = ({ open, setOpen, asistencia }) => {
  const {
    soloUnaSucursal,
    textoSucursal,
    handleOk,
    handleChange,
    changeSelect,
    body,
    filas,
    actualizarFila,
    agregarFila,
    eliminarFila,
    costoPropuesto,
    resetForm,
    loadingConfirmarProveedor,
  } = useForm(asistencia);

  const submit = async () => {
    const enviado = await handleOk();
    if (enviado) {
      resetForm();
      setOpen(false);
    }
  };

  return (
    <ModalPage
      handleOk={submit}
      handleCancel={() => setOpen(false)}
      isVisible={open}
      titulo={`Tomar Servicio - CARRETERO${
        soloUnaSucursal ? ` - ${textoSucursal}` : ""
      }`}
      okLabel="Aceptar Servicio"
      loadingOk={loadingConfirmarProveedor}
    >
      <Row gutter={[10, 10]}>
        {!soloUnaSucursal && (
          <Col span={24}>
            <SelectSucursales
              label="Sucursal encargada"
              value={body.proveedorSucursalID}
              onChange={changeSelect}
            />
          </Col>
        )}
        <Col xs={24} md={12}>
          <LabelNumber
            name="costoPropuesto"
            label="Costo Propuesto"
            value={costoPropuesto}
            disabled
          />
        </Col>
        <Col xs={24} md={12}>
          <LabelNumber
            onChange={handleChange}
            name="tiempoLlegadaPropuesto"
            label="Tiempo de Arribo"
            value={body.tiempoLlegadaPropuesto}
          />
        </Col>
        <Col span={24}>
          <ListaItems
            filas={filas}
            actualizarFila={actualizarFila}
            eliminarFila={eliminarFila}
          />
          <Button icon={<PlusOutlined />} onClick={agregarFila}>
            Agregar otro concepto
          </Button>
        </Col>
      </Row>
    </ModalPage>
  );
};
